module.exports = __webpack_public_path__ + "static/img/图形03.47b57a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/图形03.png
// module id = yrbX
// module chunks = 24